export function generateUniqueId(prefix = "id") {
  const cryptoApi = globalThis.crypto

  if (cryptoApi && typeof cryptoApi.randomUUID === "function") {
    return `${prefix}-${cryptoApi.randomUUID().replaceAll("-", "")}`
  }

  return `${prefix}-${Date.now()}-${fallbackRandomToken()}`
}

function fallbackRandomToken() {
  const cryptoApi = globalThis.crypto

  if (cryptoApi && typeof cryptoApi.getRandomValues === "function") {
    const buffer = new Uint32Array(1)
    cryptoApi.getRandomValues(buffer)
    return buffer[0].toString(36)
  }

  return Math.floor(Math.random() * 1_000_000_000).toString(36)
}
